/* eslint-disable */
export default {
      "bumblesite@ccpa.donotsell.cta": 0,
      "bumblesite@footer.apps.bumble_date": 1,
      "bumblesite@footer.apps.title": 2,
      "bumblesite@footer.company.about": 3,
      "bumblesite@footer.company.careers": 4,
      "bumblesite@footer.company.contact_us": 5,
      "bumblesite@footer.company.investors": 6,
      "bumblesite@footer.company.shop": 7,
      "bumblesite@footer.company.title": 8,
      "bumblesite@footer.download_the_app": 9,
      "bumblesite@footer.legal.a11y": 10,
      "bumblesite@footer.legal.guidelines": 11,
      "bumblesite@footer.legal.manage_cookies": 12,
      "bumblesite@footer.legal.modern_slavery_act": 13,
      "bumblesite@footer.legal.notice_at_collection": 14,
      "bumblesite@footer.legal.privacy_policy": 15,
      "bumblesite@footer.legal.terms": 16,
      "bumblesite@footer.legal.title": 17,
      "bumblesite@footer.legal.washington_consumer": 18,
      "bumblesite@footer.qr_code": 19,
      "bumblesite@german_cancelation_policy_flow.form.cta": 20,
      "bumblesite@header.navigation.menu.close.a11y.label": 21,
      "bumblesite@header.navigation.menu.open.a11y.label": 22,
      "bumblesite@language-selector.a11y.label": 23,
      "bumblesite@layout.footer.a11y.label": 24,
      "bumblesite@LAYOUT.FOOTER.ACCESSIBILITY_STATEMENT": 25,
      "bumblesite@LAYOUT.FOOTER.Apple.legal_text": 26,
      "bumblesite@LAYOUT.FOOTER.BUMBLE_BFF": 27,
      "bumblesite@LAYOUT.FOOTER.BUMBLE_BIZZ": 28,
      "bumblesite@LAYOUT.FOOTER.BUMBLE_DATE": 29,
      "bumblesite@LAYOUT.FOOTER.CAREERS": 30,
      "bumblesite@LAYOUT.FOOTER.Google_play.legal_text": 31,
      "bumblesite@LAYOUT.FOOTER.GUIDELINES": 32,
      "bumblesite@LAYOUT.FOOTER.investors": 33,
      "bumblesite@LAYOUT.FOOTER.MANAGE_COOKIES.label": 34,
      "bumblesite@LAYOUT.FOOTER.msa": 35,
      "bumblesite@LAYOUT.FOOTER.NoticeAtCollection": 36,
      "bumblesite@LAYOUT.FOOTER.PRIVACY_POLICY": 37,
      "bumblesite@LAYOUT.FOOTER.SEASONAL_DATING_GUIDES.label": 38,
      "bumblesite@LAYOUT.FOOTER.Terms": 39,
      "bumblesite@LAYOUT.FOOTER.THEAPP": 40,
      "bumblesite@LAYOUT.FOOTER.Washington_Consumer_Health_Data_Privacy_Policy.label": 41,
      "bumblesite@LAYOUT.HEADER.ABOUT": 42,
      "bumblesite@LAYOUT.HEADER.AMBASSADORS": 43,
      "bumblesite@layout.header.bumble_bff.description": 44,
      "bumblesite@layout.header.bumble_bizz.description": 45,
      "bumblesite@layout.header.bumble_date.description": 46,
      "bumblesite@layout.header.buzz": 47,
      "bumblesite@layout.header.cta.find_out_more.button": 48,
      "bumblesite@layout.header.cta.title.features.travel_mode": 49,
      "bumblesite@layout.header.date": 50,
      "bumblesite@layout.header.features": 51,
      "bumblesite@layout.header.features.compliments": 52,
      "bumblesite@layout.header.features.compliments.description": 53,
      "bumblesite@layout.header.features.discover": 54,
      "bumblesite@layout.header.features.discover.description": 55,
      "bumblesite@layout.header.features.incognito_mode": 56,
      "bumblesite@layout.header.features.incognito_mode.description": 57,
      "bumblesite@layout.header.features.instant-match": 58,
      "bumblesite@layout.header.features.instant-match.description": 59,
      "bumblesite@layout.header.features.opening_moves": 60,
      "bumblesite@layout.header.features.opening_moves.description": 61,
      "bumblesite@layout.header.features.snooze_mode": 62,
      "bumblesite@layout.header.features.snooze_mode.description": 63,
      "bumblesite@layout.header.features.superswipe": 64,
      "bumblesite@layout.header.features.superswipe.description": 65,
      "bumblesite@layout.header.features.travel_mode": 66,
      "bumblesite@layout.header.features.travel_mode.description": 67,
      "bumblesite@layout.header.features.video_chat": 68,
      "bumblesite@layout.header.features.video_chat.description": 69,
      "bumblesite@layout.header.features.web_app": 70,
      "bumblesite@layout.header.features.web_app.description": 71,
      "bumblesite@layout.header.get_the_app": 72,
      "bumblesite@layout.header.nav.friends": 73,
      "bumblesite@layout.header.safety": 74,
      "bumblesite@layout.header.stories": 75,
      "bumblesite@layout.header.support": 76,
      "bumblesite@LAYOUT.HEADER.THE_SHOP": 77,
      "bumblesite@layout.main.a11y.label": 78,
      "bumblesite@layout.modal.date.compliments.description": 79,
      "bumblesite@layout.modal.date.compliments.title": 80,
      "bumblesite@layout.modal.date.description": 81,
      "bumblesite@layout.modal.date.incognito.description": 82,
      "bumblesite@layout.modal.date.incognito.title": 83,
      "bumblesite@layout.modal.date.snooze_mode.description": 84,
      "bumblesite@layout.modal.date.snooze_mode.title": 85,
      "bumblesite@layout.modal.date.superswipe.description": 86,
      "bumblesite@layout.modal.date.superswipe.title": 87,
      "bumblesite@layout.modal.date.title": 88,
      "bumblesite@layout.modal.date.travel_mode.description": 89,
      "bumblesite@layout.modal.date.travel_mode.title": 90,
      "bumblesite@layout.modal.date.video_chat.description": 91,
      "bumblesite@layout.modal.date.video_chat.title": 92,
      "bumblesite@layout.modal.friends.community_leaders.description": 93,
      "bumblesite@layout.modal.friends.community_leaders.title": 94,
      "bumblesite@layout.modal.friends.description": 95,
      "bumblesite@layout.modal.friends.plans.description": 96,
      "bumblesite@layout.modal.friends.plans.title": 97,
      "bumblesite@layout.modal.friends.title": 98,
      "bumblesite@layout.modal.stories.description": 99,
      "bumblesite@layout.modal.stories.friendship_hub.description": 100,
      "bumblesite@layout.modal.stories.friendship_hub.title": 101,
      "bumblesite@layout.modal.stories.love_stories.description": 102,
      "bumblesite@layout.modal.stories.love_stories.title": 103,
      "bumblesite@layout.modal.stories.seasonal.description": 104,
      "bumblesite@layout.modal.stories.seasonal.title": 105,
      "bumblesite@layout.modal.stories.title": 106,
      "bumblesite@love_stories.read_more": 107,
      "bumblesite@social-links.item.a11y.label": 108,
      "bma_client@pages.faq.section.items.contact_us": 109,
      "bma_client@signin.button.signin": 110,
      "mw@link.a11y.label.new-window": 111,
      "bumble_mobile_web@company.link.faq": 112,
      "badoo_safety_center@footer.legal_links.cookie_policy": 113,
      "badoo_homepage@footer.blog": 114,
      "badoo_homepage@footer.careers": 115,
      "badoo_homepage@footer.chat": 116,
      "badoo_homepage@footer.cities": 117,
      "badoo_homepage@footer.cookies": 118,
      "badoo_homepage@footer.copyright": 119,
      "badoo_homepage@footer.dating_confidence_report": 120,
      "badoo_homepage@footer.download.copy.text": 121,
      "badoo_homepage@footer.download.title": 122,
      "badoo_homepage@footer.facebook": 123,
      "badoo_homepage@footer.follow_us.title": 124,
      "badoo_homepage@footer.help_centre": 125,
      "badoo_homepage@footer.instagram": 126,
      "badoo_homepage@footer.language.title": 127,
      "badoo_homepage@footer.linkedin": 128,
      "badoo_homepage@footer.part_of": 129,
      "badoo_homepage@footer.privacy": 130,
      "badoo_homepage@footer.safety_centre": 131,
      "badoo_homepage@footer.sitemap": 132,
      "badoo_homepage@footer.slavery_act": 133,
      "badoo_homepage@footer.terms": 134,
      "badoo_homepage@footer.twitter": 135
} as const;
